export let CHANNEL_LAYOUT_VALUES = /*#__PURE__*/function (CHANNEL_LAYOUT_VALUES) {
  CHANNEL_LAYOUT_VALUES[CHANNEL_LAYOUT_VALUES["CLASSIC"] = 1] = "CLASSIC";
  CHANNEL_LAYOUT_VALUES[CHANNEL_LAYOUT_VALUES["STRIP"] = 2] = "STRIP";
  CHANNEL_LAYOUT_VALUES[CHANNEL_LAYOUT_VALUES["COMPACT"] = 3] = "COMPACT";
  CHANNEL_LAYOUT_VALUES[CHANNEL_LAYOUT_VALUES["SLIDER_BIG"] = 4] = "SLIDER_BIG";
  CHANNEL_LAYOUT_VALUES[CHANNEL_LAYOUT_VALUES["SLIDER_SMALL"] = 5] = "SLIDER_SMALL";
  CHANNEL_LAYOUT_VALUES[CHANNEL_LAYOUT_VALUES["GRID"] = 6] = "GRID";
  return CHANNEL_LAYOUT_VALUES;
}({});
export let MOBILE_CHANNEL_LAYOUT_VALUES = /*#__PURE__*/function (MOBILE_CHANNEL_LAYOUT_VALUES) {
  MOBILE_CHANNEL_LAYOUT_VALUES[MOBILE_CHANNEL_LAYOUT_VALUES["COMPACT"] = 3] = "COMPACT";
  MOBILE_CHANNEL_LAYOUT_VALUES[MOBILE_CHANNEL_LAYOUT_VALUES["VERTICAL"] = 6] = "VERTICAL";
  return MOBILE_CHANNEL_LAYOUT_VALUES;
}({});
//# sourceMappingURL=channel-layout-values.js.map